import * as React from "react";
import EverythingProvider, {
  EverythingContext,
} from "./../components/EverythingContext";
import { filterBy } from "./../modules/filterBy";
import Layout from "./../components/Layout";
import TimelineComponent from "./../components/TimelineComponent";

const TimelinePage = () => {
  const [currentObjects, setCurrentObjects] = React.useState([]);
  const [isPristine, setIsPristine] = React.useState(true);

  return (
    <EverythingProvider>
      <EverythingContext.Consumer>
        {(allTheObjects) => {
          return (
            <Layout
              filterBy={(type, x) => {
                filterBy(type, x, allTheObjects, setCurrentObjects);
                setIsPristine(false);
              }}
            >
              <TimelineComponent
                data={
                  currentObjects.length || !isPristine
                    ? currentObjects
                    : allTheObjects
                }
              />
            </Layout>
          );
        }}
      </EverythingContext.Consumer>
    </EverythingProvider>
  );
};

export default TimelinePage;
